import { API_URL } from '../config';
import logo from '../components/common/default.png';

const getFileURL = (file_id?: number | null) => {
    if(file_id)
        return `${API_URL}/files/${file_id}`;
    else
        return logo;
};

export default getFileURL;
